var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course__comment"},[_c('h3',{domProps:{"textContent":_vm._s(_vm.$t('students.comments'))}}),_c('ul',[_vm._l((_vm.obReviews.models),function(review){return [_c('li',{key:`course-review-comment-${review.id}`},[_c('course-review-comment-item',{attrs:{"review":review}})],1)]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }